// extracted by mini-css-extract-plugin
export default {"auto-save-banner":"jYVNiB","config-list":"ZU2xva"};